import { render } from "./Riesgos.vue?vue&type=template&id=3a3faa9e"
import script from "./Riesgos.vue?vue&type=script&lang=js"
export * from "./Riesgos.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__